import html2pdf from "html2pdf.js";


export const PdfService = {
  generateQuotationPdfBlob: async (element, filename = "quotation.pdf") => {
    const opt = {
      margin: [10, 10, 10, 10], // top, left, bottom, right in mm
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, scrollY: 0 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'], before: '.page-break-before', avoid: '.no-break' }
    };

    return html2pdf().set(opt).from(element).output('blob');
  },

  // Helper to trigger download directly
  downloadPdf: async (element, filename) => {
    const opt = {
      margin: [10, 10, 10, 10], // symmetric margins top/right/bottom/left in mm
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2, 
        useCORS: true,
        scrollY: 0,
        letterRendering: true
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'], before: '.page-break-before', avoid: '.no-break' }
    };
    
    await html2pdf().set(opt).from(element).save();
  }
};
